import React, { FC, useEffect, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { FacebookIcon, InstagramIcon, TwitterIcon } from '..';
import { Logo } from './Logo';

interface Props {
  translation: any;
  logo: string;
}

export const Footer: FC<Props> = ({ translation, logo }) => {
  const classes = useStyles();
  const [isFxGiants, setIsFxGiants] = useState<boolean>(false);
  const [isFXcess, setIsFXcess] = useState<boolean>(false);
  const [isTigerFX, setIsTigerFX] = useState<boolean>(false);
  const [isXlence, setIsXlence] = useState<boolean>(false);
  const [isTradingSphere, setIsTradingSphere] = useState<boolean>(false);
  const [isIronFX, setIsIronFX] = useState<boolean>(false);

  useEffect(() => {
    if (translation.brand === 'FxGiants') {
      setIsFxGiants(true);
    }
    if (translation.brand === 'FXcess') {
      setIsFXcess(true);
    }
    if (translation.brand === 'TigerFX') {
      setIsTigerFX(true);
    }
    if (translation.brand === 'Xlence') {
      setIsXlence(true);
    }
    if (translation.brand === 'TradingSphere') {
      setIsTradingSphere(true);
    }
    if (translation.brand === 'IronFX') {
      setIsIronFX(true);
    }
  }, [translation]);

  return (
    <>
      {(isFxGiants || isFXcess) && (
        <Grid container direction="column" className={`${classes.root} ${isFxGiants ? classes.fxgiants : classes.fxcess}`}>
          {isFXcess && <Logo logo={logo} className={classes.fxcessLogo} />}
          <Typography>
            <b>{translation.brand}</b> {translation.brand_description}
          </Typography>
          <Typography>{translation.brand_note}</Typography>
          <Typography>
            <b>{translation.warning}</b> {translation.risk_warning}
          </Typography>
          <Typography>{translation.product_info}</Typography>
          <Typography>
            <b>{translation.brand_services}</b>
          </Typography>
          {isFxGiants && <Typography>{translation.all_rights_reserved}</Typography>}
          <Grid item className={classes.socialMedia}>
            <a href={isFxGiants ? 'https://x.com/fxgiants_global' : 'https://x.com/fxcess'} target="_blank" rel="noreferrer">
              <TwitterIcon />
            </a>
            <a href={isFxGiants ? 'https://www.instagram.com/fxgiants/?hl=en' : 'https://www.instagram.com/fxcess_official/'} target="_blank" rel="noreferrer">
              <InstagramIcon />
            </a>
            <a href={isFxGiants ? 'https://www.facebook.com/fxgiants/' : 'https://www.facebook.com/fxcess.official'} target="_blank" rel="noreferrer">
              <FacebookIcon />
            </a>
          </Grid>
        </Grid>
      )}
      {isTigerFX && (
        <Grid container direction="column" className={`${classes.root} ${classes.tigerFx}`}>
          <Grid item>
            <Logo logo={logo} className={classes.tigerFxLogo} />
            <Typography className={classes.brandName}>{translation.brand}</Typography>
          </Grid>
          <Grid container direction="column" className={classes.gap}>
            <Grid container direction="row" className={classes.gap}>
              <Grid item className={classes.item}>
                {translation.brand_description}
              </Grid>
              <Grid item className={classes.item}>
                {translation.risk_warning}
              </Grid>
            </Grid>
            <Typography className={classes.warning}>{translation.brand_services}</Typography>
          </Grid>
        </Grid>
      )}
      {isXlence && (
        <Grid container direction="column" className={`${classes.root} ${classes.xlence}`}>
          <Logo logo={logo} className={classes.xlenceLogo} />
          <Grid container direction="row" className={classes.xlenceInfoItems}>
            <Grid container direction="column" className={classes.xlenceItem}>
              <Grid item>{translation.brand_description}</Grid>
              <Grid item>{translation.brand_note}</Grid>
            </Grid>
            <Grid container direction="column" className={classes.xlenceItem}>
              {translation.risk_warning}
            </Grid>
          </Grid>
          <Typography className={classes.warning}>{translation.brand_services}</Typography>
        </Grid>
      )}
      {isTradingSphere && (
        <Grid container direction="column" className={`${classes.root} ${classes.TradingSphere}`}>
          <Logo logo={logo} />

          <Typography>{translation.brand_description}</Typography>
          <Typography>{translation.tradingSphere_trading_ltd}</Typography>
          <Typography>{translation.tradingSphere_novaga_ltd}</Typography>
          <Typography className={classes.TradingSphereWarning}>{translation.warning}</Typography>
          <Typography>{translation.risk_warning}</Typography>
          <Typography>{translation.brand_services}</Typography>
        </Grid>
      )}
      {isIronFX && (
        <Grid container direction="column" className={`${classes.root} ${classes.xlence}`}>
          <Grid container direction="row" className={classes.ironFXInfoItems}>
            <Grid container direction="column" className={classes.ironFXItem}>
              <Grid item>{translation.brand_description}</Grid>
              <Grid item>{translation.brand_note}</Grid>
            </Grid>
            <Grid container direction="column" className={classes.ironFXItem}>
              {translation.risk_warning}
            </Grid>
          </Grid>
          <Typography className={classes.warning}>{translation.brand_services}</Typography>
        </Grid>
      )}
    </>
  );
};
